<template>
  <div class="well well-lg">
      <div class="row">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
            <form @submit.prevent="submit()" v-if="ActiveOne != 0">
              <div class="form-group" :class="{'has-error has-feedback': errors['texto_boton']}">
                <h5 class="text-info">Titulo Multibotón</h5>
                <div class="input-group">
                    <input type="text" class="form-control input-sm" placeholder="Ingrese titulo de multibotón" id="texto_boton" @keyup.delete="LimpiarErrors"  v-model="data.multiboton" :maxlength="200">
                    <div class="input-group-btn">
                      <button v-if="data.edit_text" type="submit" class="btn btn-sm btn-primary">Actualizar </button>
                      <button v-else type="submit" class="btn btn-sm btn-primary">Actualizar </button>
                      <button v-if="data.edit_text" @click="borrarTexto" type="button" class="btn btn-sm btn-danger">Borrar</button>
                      <button v-else type="button" @click="limpiar" class="btn btn-sm btn-danger">Restablecer</button>
                    </div>
                </div>
                <div class="help-block" v-for="(e,index) in errors['texto_boton']" :key="index">{{e}}</div>
              </div>
                <dl>
                  <dt class="help-block" ><small>Notas:</small></dt>
                  <dd :class="{'hidden': ocultar_help}"  v-if="!data.edit_text" class="help-block">- <small><b>Ir al trámite en línea</b> es un texto por defecto.</small></dd>
                  <dd :class="{'hidden': !sucursal_virtual.respuesta}" class="help-block">- <small><b>Tramites en Sucursal Virtual: </b>Botón "Incluir en Ficha" Se Encuentra Activo.</small></dd>
                  <dd :class="{'hidden': !agendamiento.respuesta}"  class="help-block">- <small><b>Agendamiento: </b>Botón "Incluir en Ficha" Se Encuentra Activo.</small></dd>
                </dl>
            </form>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div id="page-nav" class="page-mobile-menu-component sidebar-menu page-sidebar hidden-xs hidden-sm">
              <h5 class="text-danger">Previsualización</h5>
              <div v-if="ActiveOne == 0">
                <div v-for="accion in acciones">
                  <button  v-if="accion.active == 1" class="btn btn-primary btn-online dropdown-toggle" type="button">
                    <img v-if="accion.clave_unica" style="width: 20px; height: 20px;" src="images/claveunica-ico.svg" alt="icono ClaveUnica" class="claveunica">
                    {{ accion.texto_boton }}
                  </button>
                </div>
              </div>
              <div class="dropdown" v-if="ActiveOne !=0">
                  <button class="btn btn-primary btn-online dropdown-toggle" type="button" 
                  id="dropdownTramiteDesk" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <div class="chev-down"></div> {{data.multiboton}}
                  </button>
                  <ul class="dropdown-menu dropdown-tramite-desk" aria-labelledby="dropdownTramiteDesk" >
                      <li v-for="accion in acciones" :key="accion.id">
                        <a v-if="accion.active">
                            <img v-if="accion.clave_unica" src="images/claveunica-ico.svg" alt="icono ClaveUnica" class="claveunica">
                            {{accion.texto_boton}}<div class="chev-right"></div>
                        </a>    
                      </li>
                      <hr v-if="sucursal_virtual.respuesta || agendamiento.respuesta" style="margin: 0 !important; border-top: 1px solid #FFFFFF;">
                      <li v-if="sucursal_virtual.respuesta">
                        <a type="button"><img :src="sucursal_virtual.icon" :alt="sucursal_virtual.nombre" />
                          {{ sucursal_virtual.nombre }}
                        </a>
                      </li>
                      <li v-if="agendamiento.respuesta">
                        <a type="button"><img :src="agendamiento.icon" :alt="agendamiento.nombre" />
                          {{ agendamiento.nombre }}
                        </a>
                      </li>
                  </ul>
              </div>
            </div>
        </div>
     </div>
  </div>
</template>

<script>
export default {
  data() {
    const data = {
      multiboton: '',
      edit_text: false,
      sucursal_virtual: [],
      agendamiento: [],
      page_id: null,
      acciones: [],
      count_active: 0,
      page_button_action_text: '',
    };
    return {
      data: data,
      errors: {},
      ocultar_help : false
    }
  },
  props: {
    text: {
      type: String,
      required: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    sucursal_virtual: {
      type: Object
    },
    agendamiento: {
      type: Object,
    },
    page_id: {
      type: Number  
    },
    acciones: {
      type: Object
    },
    count_active: {
      type: Number  
    },
    page_button_action_text: {
      type: String,
      required: false
    },
  },
  computed: {
    ActiveOne() {
      let valor = 0;
      console.log(Object.keys(this.acciones).length);

      if (Object.keys(this.acciones).length > 1 && this.count_active > 1) {
        valor = 1;
      }

      if (this.sucursal_virtual.respuesta || this.agendamiento.respuesta ) {
        valor = 2;
      }
      
      return valor;
    }
  },
  methods: {
    submit: function(){
        let self      = this;
        let errores   = {};
        let valido    = true;
        let url_axios = `backend/fichas/${ self.data.page_id }/actions/store_text_dropdown`;
        var method    = 'POST';
   
        if (self.data.multiboton.length == 0) {
          errores["texto_boton"] = [ "Este campo no puede estar vacío." ];
          valido = false;
        }

        if(self.data.multiboton.length > 30) {
          errores["texto_boton"] = ["Debe ingresar un texto más corto." ];
          valido = false;
        }
        
        if (!valido) {
          self.errors = errores;
          return false;
        }
      
        if (!confirm(`¿Está seguro que desea agregar el titulo "${ self.data.multiboton }" para el multibotón?`)) {
          return false;
        }

        axios({
            url   : url_axios,
            method: method,
            data  : self.data,
        }).then(function(response){
              window.location.replace(response.data.redirect);
        }).catch(function(error){
            // console.log(error.response);
            errores["texto_boton"] = [error.response.data.message];
            self.errors = errores;
        });
    },
    limpiar: function(){
      this.LimpiarErrors()
      this.data.multiboton = 'Ir al trámite en línea'
    },
    LimpiarErrors: function(){
      this.errors = {}
    },
    borrarTexto: function(){
      let self      = this;
      let url_axios = `backend/fichas/${ self.data.page_id }/actions/delete_text_dropdown`;
      let method    = 'POST';
      if (self.data.edit_text) {
        if (!confirm(`¿Está seguro que desea borrar el titulo del multibotón ?`)) {
          return false;
        }

        axios({
            url   : url_axios,
            method: method,
            data  : self.data,
        }).then(function(response){
              window.location.replace(response.data.redirect);
        }).catch(function(error){
            // console.log(error.response);
            errores["texto_boton"] = [error.response.data.message];
            self.errors = errores;
        });
      }
    }
  },
  watch: {
    'data.multiboton'(newValue, oldValue) {
        if(newValue != 'Ir al trámite en línea'){
          this.ocultar_help = true
        }else{
          this.ocultar_help = false
        }
    }
  },
  mounted () {

    if(this.text !== null && this.text !== ''){
        this.data.multiboton = this.text
    }else{
        if(this.page_button_action_text!== null && this.page_button_action_text!== ''){
          this.data.multiboton = this.page_button_action_text
        }else{
          this.data.multiboton = 'Ir al trámite en línea'
        }
    }
    // this.data.multiboton       = this.text !== null && this.text !== '' ? this.text : 'Ir al trámite en línea'
    this.data.edit_text        = this.edit
    this.data.sucursal_virtual = this.sucursal_virtual
    this.data.agendamiento     = this.agendamiento
    this.data.page_id          = this.page_id
    this.data.acciones         = this.acciones
    this.data.count_active     = this.count_active
  }
}
</script>

<style>
   /*Nuevos botones dropdown versión movil y desktop*/
  .bullet-page{
    padding-bottom: 5px!important;
    padding-top:5px!important;
    overflow: visible!important;
  }
  .bullet-page .help-tab{
    position:relative;
    font-size: 16px !important;
    font-family: Roboto !important;
    text-align: center;
    display: block;
    padding-top: 18px;
    padding-bottom: 14px;
    margin:0!important;
    width:97%!important
  }
  .dropup.open .help-tab{
    background-color: #dee1ef;
  }
  .bullet-page .help-tab:hover{
    text-decoration: none;
  }
  .bullet-page .help-tab:focus,  
  .bullet-page .help-tab:active{
    box-shadow: none;
    text-decoration: none;
  }
  main #page .bullet-page .btn-online,
  .bullet-page .btn-online{
    border-radius:0px !important;
    font-size: 16px !important;
    font-family: Roboto Slab !important;
    padding-top: 15px!important;
    padding-bottom:15px!important
  }
  .bullet-page .btn-online:active{
    background-color: #0b4e85;
  }

.chev-up {
    display: inline-block;
    border-right: 2px solid #0f69c4;
    border-bottom: 2px solid #0f69c4;
    width: 7px; height: 7px;
    transform: rotate(-135deg);
    margin-right: 3px;
  }
  
  
.chev-right {
  display: inline-block;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  width: 7px;
  height: 7px;
  transform: rotate(-45deg);
  margin-left: 3px;
  top: -2px;
  position: relative;
}

.btn-online .chev-up{
  display: inline-block;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  width: 7px; height: 7px;
  transform: rotate(-135deg);
  margin-right: 3px;

}

.btn-online .chev-down{   
   display: inline-block;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  width: 7px;
  height: 7px;
  transform: rotate(-315deg);
  margin-right: 7px;
  top: -4px;
  position: relative;
}
.dropdown.open .btn-online{
  background-color: #0b4e85!important;
}

.dropdown.open .btn-online .chev-down{
  transform: rotate(-135deg)!important;
  top:0px

}
.bullet-page .btn-container .row .col-xs-3, 
.bullet-page .btn-container .row .col-xs-9{
 padding:0px
}

.bullet-page .dropdown-help{
  box-shadow:none;
  width:100%!important;
  border-radius:0px;  padding:10px;
  border:0px;
  bottom:0px;
  left: 0 !important;
  width: 100% !important;
  margin-left: 0 !important;
  padding-right: 24px !important;
  padding-left: 24px !important;
  position: fixed;
  bottom:57px;
  background-color: #dee1ef!important;
  -webkit-box-shadow: 0px -3px 13px -10px #382F1D; 
  box-shadow: 0px -3px 13px -10px #382F1D;
  min-height: 230px;
}
.dropdown-help .consultas ul li a:hover img,
.dropdown-help .consultas ul li a:active img,
.dropdown-help .consultas ul li a:focus img{
  filter: invert(30%) sepia(59%) saturate(6547%) hue-rotate(-971deg) brightness(36%) contrast(74%);
}
.bullet-page .dropdown-help .cont-close a{
  text-align: right!important;
  font-family:Roboto;
  font-size: 16px;;
}
.bullet-page .consultas {
  font-family: Roboto;
  margin-top: 10px!important;
  color: #0f69b4;
  text-align: center;
  border:none!important;
  font-size: 17px;
  font-weight: 400;
  padding:0px!important;
  padding-bottom:20px!important;
  padding-top:5px!important;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
}

.bullet-page .consultas h4{
  font-family: "Roboto Slab";
  font-size: 20px;
}
.bullet-page .consultas p {
  font-family: Roboto
}
.bullet-page .consultas ul{
  text-align: center;
  margin-top:0px!important;
}
.bullet-page .consultas ul li img{
  width: 30px!important;
    height: 30px!important;
    top: 26px!important;
}
.bullet-page .consultas ul li {
  margin: 0 15px;
  margin-bottom:0px!important;
  margin-top:9px
}

.bullet-page .dropdown-tramite{
  box-shadow:none;
  width:100%!important;
  border-radius:0px;  padding:10px;
  border:0px;
  bottom:0px;
  left: 0 !important;
  width: 100% !important;
  margin-left: 0 !important;
  padding-right: 24px !important;
  padding-left: 24px !important;
  position: fixed;
  bottom:57px;
  background-color:#0b4e85;
  min-height: 230px;
}
.bullet-page .tramite{
  background-color: #0b4e85;
  color:#fff;
  list-style: none;
  margin:0!important;
  padding:0;
  margin-top:0px
}

.bullet-page .tramite li{
  margin-left:20px
}
.bullet-page .tramite li a{
  color:#fff;
  font-family: Roboto;
  font-size: 16px;
}

.bullet-page .tramite li a:active{
  color:#fff!important;

}
.bullet-page .tramite li a:focus{
  color:#fff!important;
}
.bullet-page .dropdown-tramite ul>li{
  display: block!important;
}
.bullet-page .tramite li.cont-close a{
  text-align: right;
}

.bullet-page .tramite li.cont-close{
  border-bottom: 1px solid #0f69b4;
  padding-bottom:7px;
  margin-bottom:22px!important
}
.dropdown-tramite-desk li img,
.bullet-page .tramite li img{
  width:17px;
  height:17px;
  position: absolute;
  left:20px
}
/* @media (min-width:768px){
  .dropdown-help, .dropdown-tramite{    
    bottom:67px!important;
  }
} */

#page-nav.sidebar-menu .btn-online{
  border-radius:0px!important;
  font-family: Roboto Slab!important;
  font-size: 16px!important;
}

.dropdown-tramite-desk{
  background-color: #0f69b4;
  color:#fff;
  margin:0px!important;
  border-radius: 0px;
  width:100%;
  border:none;
  padding:0px;
}
.bullet-page .dropup.open .btn-online{
  background-color: #0b4e85!important;
}
.dropdown-tramite-desk li{
  margin-bottom:6px!important
}

.dropdown-tramite-desk li:hover{
  margin-bottom:6px!important
}

.dropdown-tramite-desk li:last-child{
  margin-bottom:0px!important
}
.dropdown-tramite-desk li a{
  color:#fff;
  margin-left:25px;
  font-family: Roboto;
  font-size: 16px;
  white-space: initial;
}

.dropdown-tramite-desk li a:active{
  color:#fff!important
}

.dropdown-tramite-desk li a:focus{
  box-shadow: none!important;
  background: transparent;
  border:none;
  color:#fff!important
}
.dropdown-tramite-desk li:hover{  
  background-color: #0b4e85!important;
  display:block
}
.dropdown-tramite-desk li a:hover{
  color:#fff;
}
.dropdown-tramite-desk li a:hover{
  background-color: transparent;
}
.dropdown-tramite-desk.dropdown-menu>li>a {
  padding: 15px 40px 15px 18px;
}

.cont-close {
  text-align:right

}
.cont-close button{
  border:none;
  display:inline-block;
  text-align: right;
  background-color: transparent;
  color:#0f69b4;
  font-family:Roboto;
  font-size:16px
}
.dropdown-tramite .cont-close button{
  color:#fff
}

.bullet-page .dropdown-tramite li.cont-close{
  border-bottom: 1px solid #0f69b4;
  padding-bottom:8px;
  margin-left:0px
}
.dropdown-tramite ul li{
  margin-bottom:30px!important
}
.dropup.open #dropdownTramite .chev-up,
.dropup.open .help-tab .chev-up,
.dropup.open .help-tab .chev-up{
  transform: rotate(-316deg)!important;  
  top: -4px;
  position: relative;

}
/* Fin dropdown*/
</style>